// extracted by mini-css-extract-plugin
module.exports = {"updateDot":"UpdateDot_updateDot__32g_R","mobileUpdateDot":"UpdateDot_mobileUpdateDot__3_tY6"};